import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OverviewProjectsQueryVariables = Types.Exact<{
  date: Types.Scalars['Date']['input'];
}>;


export type OverviewProjectsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly mediaplanType?: Types.AccountsCompanyMediaplanType | null, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly provider: Types.OauthProvider, readonly lastError?: string | null, readonly isValid: boolean }>, readonly stats: ReadonlyArray<{ readonly __typename?: 'YalperStat', readonly state: Types.YalperStatsState, readonly platform: Types.YalperPlatform }>, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> }, readonly lastChecks: ReadonlyArray<{ readonly __typename?: 'YalperCheck', readonly found: number, readonly sensor: { readonly __typename?: 'YalperSensor', readonly id: string, readonly name: string } }>, readonly sensorExclusions: ReadonlyArray<{ readonly __typename?: 'YalperSensorExclusion', readonly id: string, readonly sensorName: string }>, readonly unfinishedMediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly startOn: string, readonly endOn?: string | null, readonly type: Types.AccountsMediaplanType, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly name: Types.AccountsKpiName }> | null }> }> } | null };


export const OverviewProjectsDocument = gql`
    query OverviewProjects($date: Date!) {
  currentUser {
    companies {
      id
      uuid
      name
      mediaplanType
      tokens {
        id
        provider
        lastError
        isValid
      }
      stats(date: $date) {
        state
        platform
      }
      sensorGroups {
        red
        yellow
        gray
      }
      lastChecks {
        found
        sensor {
          id
          name
        }
      }
      sensorExclusions {
        id
        sensorName
      }
      unfinishedMediaplans {
        id
        startOn
        endOn
        type
        repeat
        kpis {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useOverviewProjectsQuery__
 *
 * To run a query within a React component, call `useOverviewProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewProjectsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOverviewProjectsQuery(baseOptions: Apollo.QueryHookOptions<OverviewProjectsQueryPage, OverviewProjectsQueryVariables> & ({ variables: OverviewProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewProjectsQueryPage, OverviewProjectsQueryVariables>(OverviewProjectsDocument, options);
      }
export function useOverviewProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewProjectsQueryPage, OverviewProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewProjectsQueryPage, OverviewProjectsQueryVariables>(OverviewProjectsDocument, options);
        }
export function useOverviewProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OverviewProjectsQueryPage, OverviewProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OverviewProjectsQueryPage, OverviewProjectsQueryVariables>(OverviewProjectsDocument, options);
        }
export type OverviewProjectsQueryHookResult = ReturnType<typeof useOverviewProjectsQuery>;
export type OverviewProjectsLazyQueryHookResult = ReturnType<typeof useOverviewProjectsLazyQuery>;
export type OverviewProjectsSuspenseQueryHookResult = ReturnType<typeof useOverviewProjectsSuspenseQuery>;
export type OverviewProjectsQueryResult = Apollo.QueryResult<OverviewProjectsQueryPage, OverviewProjectsQueryVariables>;